/*
 * Module for the Employment tab of Participant Home
*/

rs.module("ui/content/participant/home/employment",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls) {

            // On change of plan/employer reload employment detail
            $.js(jsSelectors.employmentSelect).change(function () {

                $.get(backendUrls.getEmploymentDetail,
                    {
                        employmentKey: $(this).val()

                    }).done(function (results) {

                        $.js(jsSelectors.employmentDetail).html(results);
                    });
            });

        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);